// Full-screen "Activation in progress" loader shown after a successful Google
// Play popup closes, while the backend verifies the receipt and unlocks the
// entitlement server-side. Uses the same terracotta accent as the rest of the
// app for visual cohesion.

import React from 'react';

const TRANSLATIONS = {
  fr: 'Activation en cours…',
  en: 'Activation in progress…',
  es: 'Activación en curso…',
  de: 'Aktivierung läuft…',
  pt: 'Ativação em curso…',
};

export default function ActivationLoader({ isOpen, lang = 'fr' }) {
  if (!isOpen) return null;
  const label = TRANSLATIONS[lang] || TRANSLATIONS.fr;

  return (
    <div
      data-testid="activation-loader"
      role="status"
      aria-live="polite"
      aria-label={label}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        background: 'rgba(20, 12, 6, 0.72)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '28px',
        animation: 'al-fade-in 0.2s ease-out',
      }}
    >
      <style>{`
        @keyframes al-fade-in { from { opacity: 0; } to { opacity: 1; } }
        @keyframes al-spin { to { transform: rotate(360deg); } }
        .al-ring {
          width: 84px;
          height: 84px;
          border-radius: 50%;
          border: 4px solid rgba(198, 125, 91, 0.18);
          border-top-color: #C67D5B;
          border-right-color: #A65D3F;
          animation: al-spin 1s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite;
          box-shadow: 0 0 24px rgba(198, 125, 91, 0.18);
        }
      `}</style>
      <div className="al-ring" />
      <div
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '1.6rem',
          fontWeight: 500,
          color: '#FAF6F1',
          letterSpacing: '0.01em',
          textShadow: '0 2px 12px rgba(0, 0, 0, 0.35)',
        }}
      >
        {label}
      </div>
    </div>
  );
}
